import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ExportFileService {

  constructor() { }

  exportAsExcelFile(data: any[]): void {
    // Cria uma planilha (worksheet) a partir do array de dados
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    let fileName: string = crypto.randomUUID();
    
    // Cria um livro de trabalho (workbook)
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data'],
    };

    // Converte o livro de trabalho em um arquivo do tipo Excel
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    // Salva o arquivo
    this.saveAsExcelFile(excelBuffer, fileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/octet-stream',
    });
    saveAs(data, `${fileName}.xlsx`);
  }
}
